import React, { forwardRef } from 'react';

import type { DeepfakeNullableParameter } from '@vlabs/api/luna-api/model';
import { DEEPFAKE_STATE_OPTIONS } from '@vlabs/api-bindings/src/constants';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function DeepfakeFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedDeepfake = filters.deepfake ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedDeepfake.length === 0}
      onClickReset={() => updateFilters({ deepfake: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isSearchable={false}
        name="deepfake"
        onChange={(value) => updateFilters({
          deepfake: value.length > 0 ? (value as unknown as DeepfakeNullableParameter) : undefined,
        })}
        options={DEEPFAKE_STATE_OPTIONS.raw}
        value={selectedDeepfake as unknown as string[]}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const DeepfakeFilterPopoverWithRef = forwardRef(DeepfakeFilterPopover);
export { DeepfakeFilterPopoverWithRef as DeepfakeFilterPopover };
